<mat-nav-list>
    <a mat-list-item [routerLink]="['/dashboard']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
    </a>
    <a mat-list-item [routerLink]="['/organization']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin]">
        <mat-icon>groups</mat-icon>
        <span>organization</span>
    </a>
    <a mat-list-item [routerLink]="['/users']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin,Role.OrganizationAdmin]">
        <mat-icon>account_circle</mat-icon>
        <span>Users</span>
    </a>

    <a mat-list-item [routerLink]="['/holidays']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin,Role.OrganizationAdmin]">
        <mat-icon>grading</mat-icon>
        <span>Holidays</span>
    </a>

    <a mat-list-item [routerLink]="['/leave-type']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin,Role.OrganizationAdmin]">
        <mat-icon>format_list_numbered_rlt</mat-icon>
        <span>Leaves Type</span>
    </a>

    <a mat-list-item [routerLink]="['/org-leaves']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin,Role.OrganizationAdmin]">
        <mat-icon>article</mat-icon>
        <span>Organization</span>
        <span>Leaves</span>
    </a>

    <a mat-list-item [routerLink]="['/leaves']" routerLinkActive="active">
        <mat-icon>analytics</mat-icon>
        <span>Leaves</span>
    </a>
    <a mat-list-item [routerLink]="['/wfh']" routerLinkActive="active">
        <mat-icon>analytics</mat-icon>
        <span>WFH</span>
    </a>


    <a mat-list-item [routerLink]="['/attendance']" routerLinkActive="active">
        <mat-icon>how_to_reg</mat-icon>
        <span>Attendance</span>
    </a>
    <a mat-list-item [routerLink]="['/upload-files']" routerLinkActive="active">
        <mat-icon>how_to_reg</mat-icon>
        <span>Employee</span>
        <span>Files</span>
    </a>

    <a mat-list-item [routerLink]="['/screenshot']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin,Role.OrganizationAdmin,Role.UserReport]">
        <mat-icon>article</mat-icon>
        <span>Screenshots</span>
    </a>

    <a mat-list-item [routerLink]="['/reports']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin,Role.OrganizationAdmin,Role.UserReport]">
        <mat-icon>grading</mat-icon>
        <span>Reports</span>
    </a>

    <!-- <a mat-list-item [routerLink]="['/shifts']" routerLinkActive="active" *appUserRole="[Role.SuperAdmin,Role.OrganizationAdmin]">
        <mat-icon>account_box</mat-icon>
        <span>Shifts</span>
    </a> -->
</mat-nav-list>